module.exports = __webpack_public_path__ + "media/notice3.c4843eb7.mp3";